export default {
  namespaced: true,
  state: {
    buffering: false,
    activeChannel: null,
    lastChannel: localStorage.getItem('lastChannel'),
    showNavPlayer: false,
  },
  actions: {
    buffering({state, commit}, payload) {
      if (state.buffering !== payload) {
        commit('BUFFERING', payload);
      }
    },
    activeChannel({state, commit}, payload) {
      if (state.activeChannel !== payload) {
        commit('ACTIVE_CHANNEL', payload === 'null' ? false : payload);
      }
    },
    lastChannel({state, commit}, payload) {
      if (state.lastChannel !== payload) {
        commit('LAST_CHANNEL', payload);
      }
    },
    showNavPlayer({state, commit}, payload) {
      if (state.showNavPlayer !== payload) {
        commit('SHOW_NAV_PLAYER', payload);
      }
    },
  },
  mutations: {
    BUFFERING(state, buffering) {
      state.buffering = buffering;
    },
    ACTIVE_CHANNEL(state, activeChannel) {
      state.activeChannel = activeChannel;
    },
    LAST_CHANNEL(state, lastChannel) {
      state.lastChannel = lastChannel;
    },
    SHOW_NAV_PLAYER(state, show) {
      state.showNavPlayer = show;
    }
  },
}
